import request from '../utils/http'
// import storage from '../utils/storage'  
// const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 2000  // 不同小程序对接同一后台
// appid：0-维应SPR开发版、3-维应企微SPR开发版、2000-维应SPR、2003-维应企微SPR、3001-月峰教育企微SPR

// 603 买手图文-列表
export function getArticleList(data) {
    return request({
        url: '/service/view02/ams_shop_article_cmuser_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_article_cmuserpage',
            ...data
        }
    })
}

// 606 买手图文-查看
export function getArticleDetail(data) {
    return request({
        url: '/service/view02/ams_shop_article_cmuser_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_article_cmuserview',
            ...data
        }
    })
}

// 605 买手图文-修改
export function editArticle(data) {
    return request({
        url: '/service/view02/ams_shop_article_cmuser_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_shop_article_cmuseredit',
            ...data
        }
    })
}